"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var parseStringToDate = function parseStringToDate(dateString) {
  if (dateString.indexOf("T") > 0) {
    // e.g. 2022-02-18T10:30:00
    return new Date(dateString);
  } else if (dateString.match(/^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/)) {
    // e.g. 19.04.1989
    return new Date(dateString.split(".")[2], dateString.split(".")[1] - 1, dateString.split(".")[0], 0, 0, 0, 0);
  } else if (dateString.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)) {
    // e.g. 2019-12-31
    return new Date(dateString.split("-")[0], dateString.split("-")[1] - 1, dateString.split("-")[2], 0, 0, 0, 0);
  } else if (dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)) {
    // e.g. 02/18/2022
    var tmpDate = new Date(dateString);
    tmpDate.setHours(0, 0, 0, 0);
    return tmpDate;
  } else {
    console.error("parseStringToDate: no date match");
    return dateString;
  }
};
var _default = parseStringToDate;
exports.default = _default;